import React from 'react';
import {Layout} from 'antd';
import {SelectEmpresa} from '../select-empresa/select-empresa';


import './top-bar.css';



const TopBar = () => {

    // render = () => {
        const {Header} = Layout;
        
        return(
            <Header className='top-header' style={{textAlign: 'right',zIndex:10, padding: '0 24px', position: 'fixed', width: '100%', right: '0', left: '0'}}>
               <SelectEmpresa style={{textAlign: 'right'}}></SelectEmpresa>
            </Header>);
    // }
}

export {TopBar};